import type { EventNotification } from './event-notification.model';

export type ProjectFactoryAddedEventDetails = {
  factoryName?: string;
  projectName?: string;
};

/** Builds a client-side {@link EventNotification} for a factory attach to a project. */
export function createProjectFactoryAddedEvent(
  projectId: number,
  details?: ProjectFactoryAddedEventDetails
): EventNotification {
  const payload: Record<string, string> = {};

  if (details?.factoryName?.trim()) {
    payload['factory_name'] = details.factoryName.trim();
  }

  if (details?.projectName?.trim()) {
    payload['project_name'] = details.projectName.trim();
  }

  return {
    id: -Date.now(),
    created_at: new Date().toISOString(),
    event_type: 'project_factory_added',
    payload:
      payload['factory_name'] || payload['project_name'] ? payload : undefined,
    read: false,
    target_id: projectId,
    target_type: 'Project',
  };
}
